// extracted by mini-css-extract-plugin
export var aboutMe = "style-module--about-me--30XEk";
export var aboutTextContainer = "style-module--about-text-container--2uKUA";
export var profile = "style-module--profile--1h5yT";